import { render } from "./VideoComment.vue?vue&type=template&id=6de0cce9"
import script from "./VideoComment.vue?vue&type=script&lang=js"
export * from "./VideoComment.vue?vue&type=script&lang=js"

import exportComponent from "E:\\mb\\user_dashboard-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__